import {encode} from "./lib-common";

class Exclusions{
    constructor(headers){
        this.headers=headers
    }
    async create(pid,branch,exclusion,userUUID){
        try{
            if(!exclusion.content.version || !exclusion.content.version.length)exclusion.content.version="--"
            exclusion.creatorUuid=userUUID;
            exclusion.content=JSON.stringify(exclusion.content)
            const mitigationRequest= await fetch(`/api/v2/exclusions/${pid}/${window.cleanEncodeURIComponent(encode(branch))}`,{
                method: 'POST', 
                headers: this.headers,
                body: JSON.stringify(exclusion)
            })
            if(mitigationRequest.status!==200) throw await mitigationRequest.json();
            return 
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async remove(pid,branch,advice){  
        try{
            const demitigationRequest=await fetch(`/api/v2/exclusions/${pid}/${window.cleanEncodeURIComponent(encode(branch))}/${advice}`,{
                method: 'DELETE',
                headers: this.headers
            })
            if(demitigationRequest.status!==200) throw await demitigationRequest.json();
            return;
        }
		catch(e){
			throw e;
		}

    }
    map(exclusions){
        if(!exclusions) return null
        let exclusionsMap={};
        for(let section in exclusions){
            const allSectionExclusions=exclusions[section];
            for(let exclusionType in allSectionExclusions){
                const type = exclusionType
                exclusionType=allSectionExclusions[exclusionType];
                exclusionsMap={...exclusionsMap,...exclusionType.reduce((mapForCurrentSet,exclusion)=>{
                    if(!exclusion.id || mapForCurrentSet[exclusion.id]) {
                        return mapForCurrentSet;
                    }
                    mapForCurrentSet[exclusion.id]=exclusion;
                    mapForCurrentSet[exclusion.id].source=section+":"+type
                    return mapForCurrentSet;
                },{})}

            }
        }
        return exclusionsMap
    }

    async get(pid,branch){
        try{
            const request = await fetch(`/api/v2/exclusions/${pid}/${window.cleanEncodeURIComponent(encode(branch))}?expanded=true&includeExpired=true`,{
                headers: this.headers
            })
            if(request.status!==200) throw request.json()
            return this.partitionByExpiry(await request.json())
        }
        catch(e){
            return
        }
    }

    // Expired exclusions are fetched so the report can say one lapsed, never so it can
    // apply one. Everything downstream of `live` sees exactly the shape it saw before.
    partitionByExpiry(exclusionsBySection){
        const live = {}
        const expired = []
        for(const section in exclusionsBySection){
            live[section] = {}
            for(const type in exclusionsBySection[section]){
                const exclusionsOfType = exclusionsBySection[section][type] || []
                live[section][type] = exclusionsOfType.filter(exclusion => !window.ExclusionExpiry.hasExpired(exclusion))
                expired.push(...exclusionsOfType.filter(exclusion => window.ExclusionExpiry.hasExpired(exclusion)))
            }
        }
        return {live, recentlyExpired: window.ExclusionExpiry.selectRecentlyExpired(expired)}
    }
}

export default Exclusions